<span class="prizm-icon prizm-icon-{{ size }} {{ iconClass }}"></span>
